// Module
var code = "<div class=\"loader-component\"> <ng-transclude></ng-transclude> <div class=\"loader\"></div> </div> ";
// Exports
module.exports = code;